// extracted by mini-css-extract-plugin
export var chevronIcon = "_99-2";
export var teamName = "_99-1";
export var teamSwitcherButton = "_99-0";